import { Button } from "@/components/ui/button";
import type { FormValues } from "@/features/company-setup/create/form-schema";
import type { UseFormReturn } from "react-hook-form";

interface ValidationErrorAlertProps {
  onClose: () => void;
  form: UseFormReturn<FormValues>;
  currentStep: number;
}

export function ValidationErrorAlert({
  onClose,
  form,
  currentStep,
}: ValidationErrorAlertProps) {
  return (
    <div className="bg-red-50 border-l-4 border-red-400 p-4 rounded-md mb-6">
      <div className="flex">
        <div className="flex-shrink-0">
          <svg
            className="h-5 w-5 text-red-400"
            viewBox="0 0 20 20"
            fill="currentColor"
          >
            <path
              fillRule="evenodd"
              d="M10 18a8 8 0 100-16 8 8 0 000 16zM8.707 7.293a1 1 0 00-1.414 1.414L8.586 10l-1.293 1.293a1 1 0 101.414 1.414L10 11.414l1.293 1.293a1 1 0 001.414-1.414L11.414 10l1.293-1.293a1 1 0 00-1.414-1.414L10 8.586 8.707 7.293z"
              clipRule="evenodd"
            />
          </svg>
        </div>
        <div className="ml-3">
          <h3 className="text-sm font-medium text-red-800">
            Bitte überprüfen Sie Ihre Eingaben
          </h3>
          <div className="mt-1 text-sm text-red-700">
            <ul className="list-disc space-y-1">
              {currentStep === 1 && (
                <li>Füllen Sie alle erforderlichen Felder aus</li>
              )}
              {currentStep === 2 && (
                <>
                  {!form.getValues("skipDebtorsCreditorsImport") &&
                    !form.getValues("debtorsCreditorsFile") && (
                      <li>
                        Für Debitoren und Kreditoren: Bitte entweder eine Datei
                        hochladen oder "Kein Import erforderlich" auswählen
                      </li>
                    )}
                  {!form.getValues("skipAccountsImport") &&
                    !form.getValues("accountsFile") && (
                      <li>
                        Für Sachkonten: Bitte entweder eine Datei hochladen oder
                        "Kein Import erforderlich" auswählen
                      </li>
                    )}
                </>
              )}
              {currentStep === 2 && form.getValues("hasCostCenters") && (
                <li>
                  Für Kostenstellen: Bitte geben Sie die Kostenstellen in Text-
                  oder Dateiformat an
                </li>
              )}
            </ul>
          </div>
        </div>
        <div className="ml-auto pl-3">
          <div className="-mx-1.5 -my-1.5">
            <Button
              variant="ghost"
              size="sm"
              onClick={onClose}
              className="inline-flex rounded-md p-1.5 text-red-500 hover:bg-red-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-red-500"
            >
              <span className="sr-only">Dismiss</span>
              <svg className="h-5 w-5" viewBox="0 0 20 20" fill="currentColor">
                <path
                  fillRule="evenodd"
                  d="M4.293 4.293a1 1 0 011.414 0L10 8.586l4.293-4.293a1 1 0 111.414 1.414L11.414 10l4.293 4.293a1 1 0 01-1.414 1.414L10 11.414l-4.293 4.293a1 1 0 01-1.414-1.414L8.586 10 4.293 5.707a1 1 0 010-1.414z"
                  clipRule="evenodd"
                />
              </svg>
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
}
